import { EditarAspectoComponent } from "./../../../editar-aspecto/editar-aspecto.component";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";

@Component({
  selector: "app-edit-aspect-dialog",
  templateUrl: "./edit-aspect-dialog.component.html",
  styleUrls: ["./edit-aspect-dialog.component.scss"],
})
export class EditAspectDialogComponent implements OnInit {
  public aspForm: FormGroup;
  isLoading = false;
  types: string[] = [
    "d:text",
    "d:mltext",
    "d:int",
    "d:long",
    "d:float",
    "d:double",
    "d:date",
    "d:datetime",
    "d:boolean",
  ];
  isAspEdited = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditAspectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private configPastaService: ConfigurarPastaServiceService,
    private dialogoRef: MatDialogRef<EditarAspectoComponent>
  ) {
    this.dialogRef.beforeClose().subscribe((e) => {
      this.dialogRef.close(this.isAspEdited);
    });
  }

  ngOnInit() {
    // console.log(this.data);
    this.aspForm = this.fb.group({
      name: [
        { value: this.data.asp.name, disabled: true },
        Validators.required,
      ],
      title: [this.data.asp.title, Validators.required],
      desc: [this.data.asp.description],
      active: [this.data.asp.ativo, Validators.required],
    });
  }

  saveAspect() {
    this.isLoading = true;
    const aspectToSave = { ...this.data.asp };
    aspectToSave.title = this.aspForm.get("title").value;
    aspectToSave.description = this.aspForm.get("desc").value;
    aspectToSave.ativo = this.aspForm.get("active").value;

    // console.log(aspectToSave);

    this.configPastaService.editNode(aspectToSave).subscribe(
      (data) => {
        // console.log(data);
        this.isAspEdited = true;
        this.isLoading = false;
        this.openSnackBar("Aspecto atualizado com sucesso!", false);
        this.dialogoRef.close(data);
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(
          "Ocorreu um erro ao atualizar aspecto, tente novamente em alguns instantes",
          true
        );
      }
    );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/edit-aspect-dialog/edit-aspect-dialog.component.ts